import { modalStateType } from 'types';
import { ActionTypes }    from '../actions/types';


export const initialModalState: modalStateType = {
    modalVariant: 'logOut',
    showModal:    false
}

const modalReducer = (state = initialModalState, action: ActionTypes) => {

  switch (action.type) {


//SET_LRS_STATE   -      -      -      -      -      -      -      -      -      -      -      -


case 'SET_MODAL_STATE':
  {

    return {
        ...state,
        ...action.payload
    }
  }

  case 'CHANGE_MODAL_STATE':
  {

    return {
        ...state,
        modalVariant: action.payload
    }
  }
  

  

// -      -      -      -      -      -      -      -      -      -      -      -




    default: return state;
  }
};


export { modalReducer };
